export enum TongueSize {
    allen_het_harde_verhemelte_is_zichtbaar = '4 Alleen het harde verhemelte is zichtbaar',
    het_zachte_en_harde_verhemelte_zijn_zichtbaar_uvula_niet = '3 Het zachte en harde verhemelte zijn zichtbaar, uvula niet',
    onbekend = 'Onbekend',
    uvula_partieel_zichtbaar_tonsillen_slechts_gedeeltelijk_palatum_molle_en_durum_wel = '2 Uvula partieel zichtbaar, tonsillen slechts gedeeltelijk, zacht verhemelte en durum wel',
    zichtbaar_zijn_uvula_tonsillen_en_farynxbogen_palatum_molle_en_durum = '1 Zichtbaar zijn uvula, tonsillen en farynxbogen, zacht verhemelte en durum',
}
